import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { FileUploaderService } from '../service/file-uploader.service';


@Component({
  selector: 'app-edit-company',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.css']
})
export class EditCompanyComponent implements OnInit {

  errMessage = "";
  successMessage = "";
  feedbackID:string = this.route.snapshot.params.id;
  businessID: string = this.route.snapshot.params.businessID;
  authToken = localStorage.getItem('auth');
  company = [];
  users = [];
  form: FormGroup;
  messageErr;
  attachmentObj;
  isLoading = false;
  imageChangedEvent: any = '';
  croppedImage: any = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}`  }),
    withCredentials: true,
  };

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private route:ActivatedRoute,
    private fileUploaderService: FileUploaderService,
    private authService: AuthService) {

     }

     ngOnInit(): void {
      this.getBusinessDetails();

      this.form = this.fb.group({
        businessName: ['', [
          Validators.required,
        ]],
        email: ['', [
          Validators.required,
        ]],
        phone: ['', [
          Validators.required,
        ]],
  
        description: '',
        description_video_url: '',
        vatID: '',
        operator: '',
        einvoiceaddress: '',


      }); 
    }

    get email() { return this.form.get('email') };
    get businessName() { return this.form.get('businessName') };
    get phone() { return this.form.get('phone') };
    get description() { return this.form.get('description') };
    get description_video_url() { return this.form.get('description_video_url') };
    get vatID() { return this.form.get('vatID') };
    get operator() { return this.form.get('operator') };
    get einvoiceaddress() { return this.form.get('einvoiceaddress') };

    imageCropped(event: ImageCroppedEvent) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
      // event.blob can be used to upload the cropped image
    }

    saveCroppedImage() {
    
      var real_url = this.croppedImage.changingThisBreaksApplicationSecurity;
    
      // Step 1: Convert blob URL to Blob
      fetch(real_url)
        .then(response => response.blob())
        .then(blob => {
          // Step 2: Create a File object
          const filename = 'cropped_image.png'; // You can set the filename as per your requirement
          const file = new File([blob], filename, { type: 'image/png' });
    
          // Now 'file' can be used to upload or save the cropped image
          this.attachmentObj = file;
          this.addLogo('logo');
        })
        .catch(error => {
          console.error('Error converting blob URL to File:', error);
        });
    }


    getBusinessDetails() {

      this.http.get(environment.USER_BUSINESS, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {
            this.company = res.message;
  
            console.log(this.company);
            var cm = this.company[0];

            this.form = this.fb.group({
               businessName: [cm.businessName, Validators.required],
              email: [cm.email, Validators.required],
              phone: [cm.phone, Validators.required],
              description: cm.description,
              vatID: cm.vatID,
              operator: cm.operator,
              einvoiceaddress: cm.einvoiceaddress,
              description_video_url: cm.description_video_url ? 'https://youtube.com/watch?v='+cm.description_video_url : null,
            });
  
          }
          else {

          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })
  
  
    }
    gotFile(event: Event, type): void {

        const attachment = (event.target as HTMLInputElement).files[0];
        this.attachmentObj = attachment;
        this.addLogo(type);
     }
     addLogo(type) {
      console.log('addLogo', type);
      this.fileUploaderService.uploadImageServer(this.attachmentObj,(err,result) => {
      
        if(result == false){
          alert('Error while uploading image');
        }
        else{
          var logo = result;
          this.company[0].logo = logo;
          var req = {
            logo: logo,
            type: type,
          }


          this.http.post(environment.EMPLOYER_ADD_LOGO, req, this.httpOptions).subscribe(
            (res: any) => {
              if(res.status == 200 ) {
                if(type == 'logo'){
                  var businessData = JSON.parse(localStorage.getItem('company_'+this.businessID));
                  businessData[0].logo = logo;
                  localStorage.setItem('company_'+this.businessID, JSON.stringify(businessData));
                  window.location.reload();
                }
                this.getBusinessDetails();
              }
              else {
                this.errMessage = res.message;
                var anElm = document.getElementById('error');
                anElm.style.display="block";
                document.getElementById('loader').style.display="none";
              }
              
            }, (err: any) => {
        
              console.log("Error while finding status :: ", err);
            })

        }
     })
    }

    removeLogo(type){
      var deletable = this.company[0].logo;
      if(type == 'background'){
        deletable = this.company[0].mobile_banner_image;
      }
      var req = {
        logo: deletable,
        type: type,
      }
      this.http.post(environment.EMPLOYER_REMOVE_LOGO, req, this.httpOptions).subscribe(
        (res: any) => {
          if(res.status == 200 ) {

            if(type == 'logo'){
              this.company[0].logo = '';
            }
            else{
              this.company[0].mobile_banner_image = '';
            }

          }
          else {
            this.errMessage = res.message;
            var anElm = document.getElementById('error');
            anElm.style.display="block";
            document.getElementById('loader').style.display="none";
          }
          
        }, (err: any) => {
    
          console.log("Error while finding status :: ", err);
        })

    }
    
    onSubmit(){

      this.isLoading = true;
      
          if (!this.form.valid) {
            return;
          }
          var id = link_id
          var link = this.form.get('description_video_url').value;
          //check if link is youtube
          if(link != null && link != ''){
          if(link.includes('https://youtube.com/watch') || link.includes('https://www.youtube.com/watch')){
            var video_id = link.split('v=')[1];
            var ampersandPosition = video_id.indexOf('&');
            if(ampersandPosition != -1) {
              video_id = video_id.substring(0, ampersandPosition);
            }
            var link_id = video_id;
            
          }
          else{
            if(link.includes('https://youtu.be/')){
              var link_id = link.split('https://youtu.be/')[1];
            }
            else{
              alert('Linkki ei ole hyväksyttävä. Kopioi videon osoite url -kentästä.');
              return;
            }
          }
          }
          else{
            var link_id = null;
          }

      
          const request = {
            businessName: this.form.get('businessName').value,
            email: this.form.get('email').value,
            phone: this.form.get('phone').value,
            description: this.form.get('description').value,
            description_video_url: link_id,
            vatID: this.form.get('vatID').value,
            operator: this.form.get('operator').value,
            einvoiceaddress: this.form.get('einvoiceaddress').value,
          }


      
             this.http.put(environment.USER_BUSINESS, request, this.httpOptions).subscribe(
              (res: any) => {
                this.isLoading = false;
                if (res.status == 200) {
                  this.router.navigate(['/'+this.businessID+'/company-details/'])
                } 
                
                else {

                  alert(res.message);
                  //loginError = true;
                }
              }, (err: any) => {
      
                console.log("Error while login :: ", err);
              }
            )
      
          } 

          goBack(){
            window.history.back();
        }

}
